import axios from 'axios'

export const GET_COMPANY = async (businessID) =>
  axios.get(`${process.env.REACT_APP_BASE_URL}/api/users/getuser/${businessID}`)
